export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15098.71e2731e.jpg";